import React from "react";
import UserContextType from "./UserContextType";

const UserContext = React.createContext<UserContextType>({
    user: undefined,
    setUser: () => {}
});

export default UserContext;